import React, {useEffect} from 'react'
import { connect } from "react-redux";
import { useGoogleLogin } from '@react-oauth/google'
import axios from "axios"

import FacebookIcon from '../FacebookIcon'
import GoogleIcon from '../GoogleIcon'
import ClientButton from '../ClientButton'
import { externalLoginClient } from '../../store/actions/clients'
import translations from '../../utils/translations'
import crossIcon from '../../images/2-icons8-cross-96.png'
import envelopeIcon from '../../images/icons8-envelope-100.png'
import colors from '../../constants/colors'

const LoginModal = (props) => {
    const {
        setLoginModal,
        externalLoginClient,
        
        currentTranslations,
    } = props

    const login = useGoogleLogin({
        onSuccess: async (credentialRes)=>{
            if(credentialRes?.access_token){
                const d = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: {
                        Authorization: `Bearer ${credentialRes?.access_token}`
                    }
                })
                props.externalLoginClient(
                    {
                        name: d?.data?.name,
                        external_id: d?.data?.sub,
                        external_token: credentialRes?.access_token,
                        email: d?.data?.email,
                        google_image_url: d?.data?.picture,
						image: d?.data?.picture,
						auth_provider: 'google',
                    },
                    'google'
                );
            }
        } 
    })

    const providers = [
        {
            Logo: (
                <GoogleIcon 
                    style={{
                        height: '40px', 
                        width: '40px',
                        padding: '8px', 
                        borderRadius: '50px', 
                        border: '1px solid'
                    }}
                />
            ),
            style: {border: '1px solid', overflow: 'hidden',},
            onClick: login,
        },
        {
            Logo: (
                <FacebookIcon 
                    style={{
                        height: '40px', 
                        width: '40px',
                        padding: '8px', 
                        borderRadius: '50px', 
                        backgroundColor: colors?.facebookBlue,
                    }}
                />
            ),
            onClick: () => {},
        },
        {
            image: envelopeIcon,
            style: { backgroundColor: colors.gray},
            onClick: () => {},
        },
    ]

    return (
        <div 
            style={{
                display: 'flex',
                position: 'absolute', 
                top: '0px', 
                height: '120%', 
                width: '100%', 
                backgroundColor: 'rgba(0,0,0,0.5)',
                justifyContent: 'center',
                zIndex: 111,
            }}
        >
            {/* white container */}
            <div style={{backgroundColor: 'white', width: '80%', height: 'fit-content', borderRadius: '15px', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5vh 35px', margin: '15vh 0px', textAlign: 'center', }}>
                <img src='https://img.icons8.com/?size=100&id=IT-x6XCdBTA_&format=png&color=000000' style={{height: '11vh', width: '11vh' }}/>

                {/* Instructions */}
                <div style={{margin: '2vh 0vh 0vh 0vh', fontWeight: 'bold', fontSize: '16px', }}>
                    {currentTranslations?.getDiscounts}
                </div>
                
                {/* Instructions */}
                <div style={{margin: '4vh 0vh 0vh 0vh', fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)'}}>
                    {currentTranslations?.signUpWith?.toUpperCase()}
                </div>

                {/* Auth providers */}
                <div style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '15px', margin: '1vh 0px 0px 0px'}}>
                    {/*  */}
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-around', alignItems: 'center'}}>
                        {providers?.map(({Logo, image, onClick})=>{
                            return Logo ? (
                                <ClientButton 
                                    style={{ 
                                        height: 'fit-content',
                                        width: 'fit-content',
                                        position: 'relative',
                                    }}
                                    onClick={onClick}
                                >
                                    {Logo}
                                </ClientButton>
                            ) : (
                                <ClientButton
                                    onClick={()=>window.location.href = `${process.env.REACT_APP_ENDPOINT}/account_register?type=client`}
                                    style={{ 
                                        borderRadius: '50px', 
                                        overflow: 'hidden',
                                        padding: '11px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: 'fit-content',
                                        width: 'fit-content',
                                    }}
                                >
                                    <img 
                                        src={image} 
                                        style={{
                                            height: '20px', 
                                            width: '20px',
                                        }}
                                    />
                                </ClientButton>
                            )
                        })}
                    </div>

                    {/* email */}
                    <ClientButton 
                        onClick={()=>window.location.href = `${process.env.REACT_APP_ENDPOINT}/account_register?type=client`}
                        style={{
                            backgroundColor: colors?.gray, 
                            width: '100%', 
                            height: 'fit-content',
                            borderRadius: '5px', 
                            fontWeight: '600', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            padding: '5px 0px',
                            margin: '2vh 0px 0px 0px',
                            fontSize: '14px',
                        }}
                    >
                        <img src={envelopeIcon} style={{width: '2vh', height: '2vh', margin: '0px 10px 0px 0px'}}/>
                        {currentTranslations?.email}
                    </ClientButton>
                </div>
                
                <ClientButton 
                    onClick={()=>window.location.href = `${process.env.REACT_APP_ENDPOINT}/login_client`}
                    style={{
                        color: 'blue', 
                        fontWeight: '600', 
                        margin: '4vh 0px 0px 0px', 
                        fontSize: '14px',
                        height: 'fit-content', 
                        width: 'fit-content',
                    }}
                >
                    {currentTranslations?.allSet}
                </ClientButton>

                {/* close button */}
                <ClientButton 
                    onClick={()=>setLoginModal(false)}
                    style={{
                        position: 'absolute', 
                        zIndex: 11111, 
                        top: '7px', 
                        right: '7px', 
                    }}
                >
                    <img src={crossIcon} style={{width: '28px', height: '28px', }}/>
                </ClientButton>
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch) => ({
    setLoginModal: (payload) => dispatch({type: 'SET_LOGIN_MODAL', payload,}),
    externalLoginClient: (client, platform) => dispatch(externalLoginClient(client, platform)),
});

const mapStateToProps = (state) => ({
  currentTranslations: translations[state.app.lang],
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);